var _ellipse, _path, _path2, _path3, _ellipse2, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWageredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 97,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 10.5,
    rx: 25,
    ry: 10.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 50c0 12-7 16-25 16C7 66 0 62 0 50c0-6 5 2 12 4 4 2 8 2 13 2 7 0 13-1 18-3 5-3 8-7 8-3Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65c0 12-7 16-25 16C7 81 0 77 0 65c0-6 5 2 12 4 4 2 8 2 13 2 7 0 13-1 18-3s8-7 8-3Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 80c0 12-7 16-25 16C7 96 0 92 0 80c0-6 5 2 12 4 4 2 8 2 13 2 7 0 13-1 18-3s8-7 8-3Z",
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26,
    cy: 40.5,
    rx: 25,
    ry: 10.5,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 36c18 0 25-4 25-16 0-3-1-2-4 0l-4 3c-5 2-11 3-18 3h-1c-5 0-8 0-12-2l-8-4c-2-2-4-3-4 0l1 5c11 1 20 5 20 10v1h5ZM55 81h6c18 0 25-4 25-16 0-3-1-2-4 0l-4 3c-5 2-11 3-18 3h-5v10Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 51h6c18 0 25-4 25-16 0-3-1-2-4 0l-4 3c-5 2-11 3-18 3h-5v10Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 66h6c18 0 25-4 25-16 0-3-1-2-4 0l-4 3c-5 2-11 3-18 3h-5v10Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWageredIcon);
export default __webpack_public_path__ + "static/media/wagered_icon.ec18e148288842ed13ce3826f67f05b0.svg";
export { ForwardRef as ReactComponent };